(function () {
  const onAccordionClick = (event) => {
    const button = event.target.closest('[data-accordion-toggle]');
    if (!button) return;

    const panelId = button.getAttribute('aria-controls');
    if (!panelId) return;

    const panel = document.getElementById(panelId);
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));

    if (panel) {
      panel.hidden = expanded;
    }

    const openIcon = button.querySelector('.icon-open');
    const closedIcon = button.querySelector('.icon-closed');
    if (openIcon) openIcon.classList.toggle('hidden');
    if (closedIcon) closedIcon.classList.toggle('hidden');
  };

  document.addEventListener('click', onAccordionClick);
})();
